import { html, ref, when } from '@microsoft/fast-element';
import type { IndividualProject } from './individual-project';
import { sync } from '@genesislcap/foundation-utils';
import { eventDetail } from '../../utils/formatting';
import { pencilIcon } from '../../styles';
import { PROFILE_RIGHTS } from '../../utils';

export const IndividualProjectTemplate = html<IndividualProject>`
  <div class="cascade-route-content">
    <!-- Entire Dashboard Route -->
    <div class="individual-project">
      <zero-card class="no-padding-card">
        <zero-tabs>
          <zero-tab slot="tab">Project Metrics</zero-tab>
          <zero-tab slot="tab">Overview</zero-tab>
          <zero-tab-panel class="individual-project-tab" slot="tabpanel">
            <individual-projects-drilldown
              @createProposal="${(x, c) => x.createProposal(eventDetail(c))}"
              @editVppa="${(x, c) => x.editVppa(eventDetail(c))}"
              @copyVppa="${(x, c) => x.copyVppa(eventDetail(c))}"
              @deleteVppa="${(x, c) => x.deleteVppa(eventDetail(c))}"
              @downloadVppa="${(x, c) => x.downloadVppa(eventDetail(c))}"
              @openModal="${(x, c) => x.openVppaModal()}"
              @openMoreInfoModal="${(x, c) => x.openMoreInfoModal(eventDetail(c))}"
              ${ref('projectDrilldown')}
            ></individual-projects-drilldown>
          </zero-tab-panel>
          <zero-tab-panel class="project-drilldown-tab" slot="tabpanel">
            <individual-projects-overview ${ref('projectOverview')}></individual-projects-overview>
          </zero-tab-panel>
          <tab-buttons slot="end">
            ${when(
              (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.UPSERT_PROJECT),
              html<IndividualProject>`
                <zero-button
                  appearance="card-secondary"
                  slot="buttons"
                  @click="${(x) => x.editProject()}"
                >
                  ${pencilIcon('start')} Edit Project
                </zero-button>
              `,
            )}
          </tab-buttons>
        </zero-tabs>
      </zero-card>
    </div>
  </div>
  <vppa-modal ${ref('vppaModal')}></vppa-modal>
  <project-modal ${ref('projectModal')}></project-modal>
  <more-info-modal ${ref('moreInfoModal')}></more-info-modal>
  <cancel-modal
    ${ref('cancelModal')}
    @confirmCancel="${(x, c) => x.cancelVppa(eventDetail(c))}"
  ></cancel-modal>
`;
